/** Matches the API meta type for a user that exists only to carry a seller code. */
export const CODE_ONLY_ADVISOR_TYPE = "advisor.code";

export const ADVISOR_MODE_EXISTING = "existing";

export const ADVISOR_MODE_NEW = "new";

export const isCodeOnlyAdvisor = (user) => {
  const meta = user && user.meta;
  if (!meta) return false;
  return meta.type === CODE_ONLY_ADVISOR_TYPE || meta.loginDisabled === true;
};

export const buildSellerMappingInput = ({
  userId,
  isNewAdvisor,
  firstname,
  lastname,
  rangeId,
  sellerCode,
  apiPassword,
  id,
}) => {
  const code = (sellerCode || "").trim();
  if (!code) return null;

  const user = isNewAdvisor
    ? {
        firstname: (firstname || "").trim(),
        lastname: (lastname || "").trim(),
      }
    : { id: userId };

  if (isNewAdvisor && (!user.firstname || !user.lastname)) return null;
  if (!isNewAdvisor && !userId) return null;

  const password = (apiPassword || "").trim();
  return {
    id,
    sellerCode: code,
    ...(password ? { apiPassword: password } : {}),
    user,
    ...(rangeId ? { productRange: { id: rangeId } } : {}),
  };
};
